export default build =>
    build.mutation({
        query(payload) {
            return {
                url: `/exam/editexamform`,
                method: 'POST',
                body: payload
            };
        },
        invalidatesTags: ['allExamFormsByAgents']

    })
